export default __webpack_public_path__ + "static/wallet1-840edfaff78ddc68cf5cb514c5db8518.png";